// extracted by mini-css-extract-plugin
export default {"xs":"Space_xs__DCgBZ","s":"Space_s__hO-D0","sm":"Space_sm__7Pg50","m":"Space_m__SUgr8","l":"Space_l__fJgXK","xl":"Space_xl__IFznq"};